import { render, staticRenderFns } from "./RankChangeNew.vue?vue&type=template&id=395c5ad8&"
import script from "./RankChangeNew.vue?vue&type=script&lang=js&"
export * from "./RankChangeNew.vue?vue&type=script&lang=js&"
import style0 from "./RankChangeNew.vue?vue&type=style&index=0&id=395c5ad8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports